import { Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@chakra-ui/react'

import React from 'react'

interface Props {
    isOpen: boolean,
    onClose: () => void
}

export const PrivacyModal : React.FC<Props> = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} scrollBehavior="outside">
        <ModalOverlay/>
        <ModalContent maxW="50%">
        <ModalHeader>
            Privacy policy
        </ModalHeader>
        <ModalCloseButton/>
        <ModalBody>
        <p>
              <span style={{ fontSize:"20px", fontWeight:"bold" }}>1. Introduction</span>
              <br/>  
              We are committed to safeguarding the privacy of our website users. This policy applies to all personal data collected, used, and shared by our platform.
            </p>
            <br />
            <p>
              <span style={{ fontSize:"20px", fontWeight:"bold" }}>2. Information We Collect</span>
              <br/>
              We may collect personal information such as name, email address, phone number, and other details you provide to us. We use this information to improve our services and for communication purposes.
            </p>
            <br />
            <p>
              <span style={{ fontSize:"20px", fontWeight:"bold" }}>3. Use of Personal Data </span>
              <br/>
              We use your personal data for the following purposes: to provide our services, to communicate with you, and to improve our website. We do not share your information with third parties without your consent.
            </p>
            <br />
            <p>
              <span style={{ fontSize:"20px", fontWeight:"bold" }}>4. Data Security  </span>
              <br/>
              We implement appropriate technical and organizational measures to ensure the security of your personal data.
            </p>
            <br />
            <p>
              <span style={{ fontSize:"20px", fontWeight:"bold" }}>5. Your Rights  </span>
              <br/>
              You have the right to access, correct, or delete your personal information at any time. Contact us for assistance regarding your privacy rights.
            </p>
            <br />
            <p>
              <span style={{ fontSize:"20px", fontWeight:"bold" }}>6. Changes to This Policy </span>
              <br/>
              We may update our privacy policy from time to time. We encourage you to review this page periodically for any changes.
            </p>
        </ModalBody>
        <ModalFooter>
            <Button
              _hover={{ backgroundColor: "grey" }}
              padding="16px 28px"
              color="white"
              backgroundColor="#4A2C2A"
              mr={3}
              onClick={onClose}
            >
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
    </Modal>
  )
}
